<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="zh"></div>
      <!-- <div @click="getFileList">1111111</div> -->
      <!-- <div @click="generateQrcode">22222222222222</div> -->
      <!-- <div @click="getSMfirm">查询企业信息</div> -->
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否有企业">
              <el-switch v-model="enterprise"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <div v-if="enterprise">
            <div class="border-box">
              <div class="hood-title">基本信息</div>
              <el-row>

                <el-col :span="24">
                  <el-form-item label="企业类型（组成形式）" label-width="auto">
                    <el-radio-group v-model="form.entType">
                      <el-radio-button label="1">有限责任公司</el-radio-button>
                      <el-radio-button label="2">股份有限公司</el-radio-button>
                      <el-radio-button label="3">外资有限责任公司</el-radio-button>
                      <el-radio-button label="4">外资股份有限公司</el-radio-button>
                      <el-radio-button label="5">个体工商户</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <div v-if="form.entType.includes('5')"> -->
              <!-- <el-row>
                <el-col :span="8">
                  <el-form-item label="名称">
                    <el-input v-model="form.entName" placeholder="名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话">
                    <el-input v-model="form.entTel" placeholder="联系电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="邮政编码">
                    <el-input v-model="form.entPostalCode" placeholder="邮政编码"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row>
                <el-col :span="16">
                  <el-form-item label="经营场所">
                    <el-input type="textarea" v-model="form.entAddress" placeholder="经营场所(省/市/区/门牌号)"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="电子商务经营者">
                    <el-radio-group v-model="form.ECommerce">
                      <el-radio-button label="1">是</el-radio-button>
                      <el-radio-button label="0">否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row>
                <el-col :span="16">
                  <el-form-item label="名称">
                    <el-input v-model="form.entName" placeholder="名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话">
                    <el-input v-model="form.entTel" placeholder="联系电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="邮政编码">
                    <el-input v-model="form.entPostalCode" placeholder="邮政编码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="住所(经营场所)">
                    <el-input v-model="form.entAddress" placeholder="经营场所(省/市/区/门牌号))"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="申领执照(申领纸质营业执照其中：副本1个)">
                    <!-- <el-switch v-model="form.applyLicense"></el-switch> -->
                    <!-- 申领纸质营业执照其中：副本1个 -->
                    <el-radio-group v-model="form.applyLicense">
                      <el-radio-button label="1">是</el-radio-button>
                      <el-radio-button label="2">否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="文书送达方式">
                    <el-radio-group v-model="form.entMailType">
                      <el-radio-button label="1">邮寄送达</el-radio-button>
                      <el-radio-button label="2">现场领取</el-radio-button>
                      <el-radio-button label="3">其他</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="20" v-if="form.entMailType == '1'">
                  <el-form-item label="邮寄地址">
                    <el-input v-model="form.mailAddress" placeholder="邮寄地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!form.entType.includes('5')">
                <el-col :span="8">
                  <el-form-item label="设立方式（股份公司填写）" label-width="auto">
                    <el-radio-group v-model="form.entEstablishment">
                      <el-radio-button label="1">发起设立</el-radio-button>
                      <el-radio-button label="2">募集设立</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="注册资本（万元）">
                    <el-input v-model="form.entCapital" placeholder="注册资本（万元）"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col :span="8">
                  <el-form-item label="电子商务经营者">
                    <el-radio-group v-model="form.ECommerce">
                      <el-radio-button label="1">是</el-radio-button>
                      <el-radio-button label="0">否</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出资额（万元）">
                    <el-input v-model="form.entCapital" placeholder="出资额（万元）"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <el-form-item label="经营范围">
                    <el-input type="textarea" v-model="form.licenseScope" placeholder="经营范围"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="border-box" v-if="!form.entType.includes('5')">
              <div class="hood-title">法定代表人</div>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="姓名">
                    <el-input v-model="form.lerepName" placeholder="姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="国别（地区）">
                    <el-input v-model="form.lerepCountry" placeholder="国别（地区）"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="职务">
                    <el-radio-group v-model="form.lerepPosition">
                      <el-radio-button label="1">董事长</el-radio-button>
                      <el-radio-button label="2">执行董事</el-radio-button>
                      <el-radio-button label="3">经理</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产生方式">
                    <el-input v-model="form.lerepProduceType" placeholder="产生方式"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学历">
                    <el-input v-model="form.lerepEducational" placeholder="学历"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="职称">
                    <el-input v-model="form.lerepJob" placeholder="职称"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="身份证件类型">
                    <el-input v-model="form.lerepCernoType" placeholder="身份证件类型"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证件号码">
                    <el-input v-model="form.lerepCerno" placeholder="身份证件号码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="移动电话" placeholder="移动电话">
                    <el-input v-model="form.lerepTel" placeholder="移动电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="电子邮箱">
                    <el-input v-model="form.lerepEmail" placeholder="电子邮箱"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证件登记住址">
                    <el-input v-model="form.lerepDJAddress" placeholder="证件登记住址"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="现住址">
                    <el-input v-model="form.lerepAddress" placeholder="现住址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="border-box" v-if="!form.entType.includes('5')">
              <div class="hood-title">董事、监事、经理信息<span class="tips">(担任法定代表人的董事长、执行董事、经理不重复填写)</span></div>
              <el-button type="primary" @click="addLeadership">添加</el-button>
              <el-table :data="form.directorMessage" stripe style="width: 100%">
                <el-table-column prop="name" label="姓名">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" placeholder="姓名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="country" label="国别(地区)">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.country" placeholder="国别(地区)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="cernoType" label="身份证件类型">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.cernoType" placeholder="身份证件类型"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="cerno" label="身份证件号码">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.cerno" placeholder="身份证件号码"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="job" label="职务">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.job" placeholder="职务"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="generationMode" label="产生方式">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.generationMode" placeholder="产生方式"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="border-box" v-if="!form.entType.includes('5')">
              <div class="hood-title">股东（发起人）、外国投资者出资情况（必填项）<span class="tips">(单位：万元)</span></div>
              <el-button type="primary" @click="addShareholder">添加</el-button>
              <el-table :data="form.shareholderMessage" stripe style="width: 100%">
                <el-table-column prop="name" label="姓名">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" placeholder="姓名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="country" label="国别(地区)">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.country" placeholder="国别(地区)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="cernoType" label="身份证件类型">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.cernoType" placeholder="身份证件类型"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="cerno" label="身份证件号码">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.cerno" placeholder="身份证件号码"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="contributionAmount" label="认缴出资额">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.contributionAmount" placeholder="认缴出资额"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="investmentAmount" label="实缴出资额">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.investmentAmount" placeholder="实缴出资额"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="contributeTime" label="出资（认缴）时间">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.contributeTime" placeholder="出资（认缴）时间"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="investmentType" label="出资方式">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.investmentType" placeholder="出资方式"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="investmentRatio" label="出资比例">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.investmentRatio" placeholder="出资比例"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="border-box">
              <div class="hood-title">联络员信息(必填项)</div>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="姓名">
                    <el-input v-model="form.contactName" placeholder="姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="固定电话">
                    <el-input v-model="form.contactPhone" placeholder="固定电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="移动电话">
                    <el-input v-model="form.contactTel" placeholder="移动电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="电子邮箱">
                    <el-input v-model="form.contactEmail" placeholder="电子邮箱"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证件类型">
                    <el-input v-model="form.contactCernoType" placeholder="身份证件类型"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证件号码">
                    <el-input v-model="form.contactCerno" placeholder="身份证件号码"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="border-box">
              <div class="hood-title">指定代表/委托代理人（必填项）</div>
              <div class="hood-title"><span class="tips">委托权限</span></div>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="对登记材料中的复印件并签署核对意见" label-width="251px">
                    <el-radio-group v-model="form.CheckRadio">
                      <el-radio-button label="1">同意</el-radio-button>
                      <el-radio-button label="2">不同意</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="修改企业自备文件的错误" label-width="251px">
                    <el-radio-group v-model="form.ModifyRadio">
                      <el-radio-button label="1">同意</el-radio-button>
                      <el-radio-button label="2">不同意</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="修改有关表格的填写错误" label-width="251px">
                    <el-radio-group v-model="form.ChangeRadio">
                      <el-radio-button label="1">同意</el-radio-button>
                      <el-radio-button label="2">不同意</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="领取营业执照和有关文书" label-width="251px">
                    <el-radio-group v-model="form.CollectRadio">
                      <el-radio-button label="1">同意</el-radio-button>
                      <el-radio-button label="2">不同意</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="固定电话">
                    <el-input v-model="form.representativePhone" placeholder="固定电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="移动电话">
                    <el-input v-model="form.representaTel" placeholder="移动电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="指定代表/委托代理人签字">
                    <el-button type="primary" @click="toSign(1)">签字</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="border-box" v-if="!form.entType.includes('5')">
              <div class="hood-title">山东省“多证合一”涉企证照事项申请书</div>
              <div class="hood-title"><span class="tips">财务负责人信息</span></div>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="姓名">
                    <el-input v-model="form.financialName" placeholder="姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="固定电话">
                    <el-input v-model="form.financialPhone" placeholder="固定电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="移动电话">
                    <el-input v-model="form.financialTel" placeholder="移动电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="电子邮箱">
                    <el-input v-model="form.financialEmail" placeholder="电子邮箱"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证件类型">
                    <el-input v-model="form.financialCernoType" placeholder="身份证件类型"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证件号码">
                    <el-input v-model="form.financialCerno" placeholder="身份证件号码"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="hood-title"><span class="tips">其他信息</span></div>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="核算方式 ">
                    <el-radio-group v-model="form.accountingType">
                      <el-radio-button label="1">独立核算</el-radio-button>
                      <el-radio-button label="2">非独立核算</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="hood-title"><span class="tips">印章备案信息</span></div>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="所属地市">
                    <el-input v-model="form.whichBelongs" placeholder="所属地市"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所属区县">
                    <el-input v-model="form.whichPrefecture" placeholder="所属区县"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="刻章企业">
                    <el-input v-model="form.whichEntName" placeholder="刻章企业"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="hood-title">申请事项情况</div>
          <el-row>
            <el-col :span="24">
              <el-form-item label="申请项目 ">
                <el-checkbox-group v-model="form.marsterName">
                  <el-checkbox-button :label="item.id" name="type" v-for="item in applyProject" :key="item.id">{{
                    item.name
                  }}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="border-box" v-if="form.marsterName.includes(3)">
            <div class="hood-title">公共场所卫生许可</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="职工人数">
                  <el-input v-model="form.industryHygieneLicense.employeeNumber" placeholder="职工人数"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="应体检人数">
                  <el-input v-model="form.industryHygieneLicense.physicalNumber" placeholder="应体检人数"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="固定资产（万元）">
                  <el-input v-model="form.industryHygieneLicense.fixedAssets" placeholder="固定资产（万元）"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="使用面积">
                  <el-input v-model="form.industryHygieneLicense.usableArea" placeholder="职工人数"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="集中式中央空调">
                  <el-radio-group v-model="form.industryHygieneLicense.isAirConditioning">
                    <el-radio-button label="1">有</el-radio-button>
                    <el-radio-button label="0">无</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请经营项目">
                  <el-input v-model="form.industryHygieneLicense.applyProject" placeholder="申请经营项目"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="许可范围">
                  <el-checkbox-group v-model="form.industryHygieneLicense.licenseScope">
                    <el-checkbox-button :label="item.name" v-for="item in scopeList" :key="item.scopeid">{{
                      item.name
                    }}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="border-box" v-if="form.marsterName.includes(1)">
            <!-- <div class="border-box"> -->
            <div class="hood-title">食品经营许可</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="预包装食品销售">
                  <el-radio-group v-model="form.industryHygieneLicense.prefabricatedFood">
                    <el-radio-button label="1">含冷藏冷冻食品</el-radio-button>
                    <el-radio-button label="0">不含冷藏冷冻食品</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="散装食品销售">
                  <el-radio-group v-model="form.industryHygieneLicense.bulkFood">
                    <el-radio-button label="0">含冷藏冷冻食品含熟食</el-radio-button>
                    <el-radio-button label="1">含冷藏冷冻食品不含熟食</el-radio-button>
                    <el-radio-button label="2">不含冷藏冷冻食品含熟食</el-radio-button>
                    <el-radio-button label="3">不含冷藏冷冻食品不含熟食</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="特殊食品销售">
                  <el-radio-group v-model="form.industryHygieneLicense.specialFood">
                    <el-radio-button label="0">婴幼儿配方乳粉</el-radio-button>
                    <el-radio-button label="1">其他婴幼儿配方食品</el-radio-button>
                    <el-radio-button label="2">保健食品销售</el-radio-button>
                    <el-radio-button label="3">特殊医学用途配方食品</el-radio-button>
                    <el-radio-button label="4">热食类食品制售</el-radio-button>
                    <el-radio-button label="5">冷食类食品制售</el-radio-button>
                    <el-radio-button label="6">生食类食品制售</el-radio-button>
                    <el-radio-button label="7">糕点类制售（含裱花蛋糕）</el-radio-button>
                    <el-radio-button label="8">糕点类制售（不含裱花蛋糕）</el-radio-button>
                    <el-radio-button label="9">自制饮品制售（不含使用压力容器制作饮品）</el-radio-button>
                    <el-radio-button label="10">其他类食品销售</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="如申请自制饮品制售，是否含自酿酒制售" label-width="auto">
                  <el-radio-group v-model="form.industryHygieneLicense.isWine">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="0">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否利用自动售货设备从事食品销售" label-width="auto">
                  <el-radio-group v-model="form.industryHygieneLicense.vendingMachine">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="0">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否含网络经营" label-width="auto">
                  <el-radio-group v-model="form.industryHygieneLicense.isNetwork">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="0">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="hood-title"><span class="tips">安全、质量管理人员、专业技术人员情况</span></div>
            <el-table :data="form.shipinPeople" stripe style="width: 100%">
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="姓名"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sex" placeholder="性别"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="nationality" label="民族">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.nationality" placeholder="民族"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="educational" label="学历/职称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.educational" placeholder="学历/职称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="nature" label="岗位性质">
              </el-table-column>
              <el-table-column prop="cerno" label="身份证号码">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.cerno" placeholder="身份证号码"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="job" label="职务">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.job" placeholder="职务"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="tel" label="联系电话">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.tel" placeholder="联系电话"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div class="hood-title"><span class="tips">从业人员情况</span></div>
            <el-button type="primary" @click="addShipinPractitioners">添加</el-button>
            <el-table :data="form.shipinPractitioners" stripe style="width: 100%">
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="姓名"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sex" placeholder="性别"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="nationality" label="民族">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.nationality" placeholder="民族"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="cerno" label="身份证号码">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.cerno" placeholder="身份证号码"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="tel" label="联系电话">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.tel" placeholder="联系电话"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="jkzNo" label="健康证编号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.jkzNo" placeholder="健康证编号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="jobType" label="工种">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.jobType" placeholder="工种"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="发证单位">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.unit" placeholder="发证单位"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <!-- shipinEquipment -->
            <div class="hood-title"><span class="tips">与经营范围相适应的设施设备情况</span></div>
            <el-button type="primary" @click="addShipinEquipment">添加</el-button>
            <el-table :data="form.shipinEquipment" stripe style="width: 100%">
              <el-table-column prop="num" label="序号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="序号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.count" placeholder="数量"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="位置">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.address" placeholder="位置"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" placeholder="备注"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-row>
              <el-col :span="8">
                <el-form-item label="姓名">
                  <el-input v-model="form.name" placeholder="姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别">
                  <el-input v-model="form.name" placeholder="性别"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="民族">
                  <el-input v-model="form.name" placeholder="民族"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="学历/职称">
                  <el-input v-model="form.name" placeholder="学历/职称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="岗位性质">
                  <el-input v-model="form.name" placeholder="岗位性质"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证号码">
                  <el-input v-model="form.name" placeholder="身份证号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
          </div>
          <div class="border-box" v-if="form.marsterName.includes(5)">
            <div class="hood-title">出版物零售单位设立审批</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="出版物发行申请项目内容" label-width="181px">
                  <el-input v-model="form.publicationInfo.name" placeholder="出版物发行申请项目内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经营场所面积(自有㎡)" label-width="181px">
                  <el-input v-model="form.publicationInfo.usedArea" placeholder="经营场所面积(自有㎡)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经营场所面积(租用㎡)" label-width="181px">
                  <el-input v-model="form.publicationInfo.leasedArea" placeholder="经营场所面积(租用㎡)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="其中仓库(㎡)" label-width="181px">
                  <el-input v-model="form.publicationInfo.warehouseArea" placeholder="其中仓库(㎡)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="相应计算机型号、数量等" label-width="181px">
                  <el-input type="textarea" v-model="form.publicationInfo.computerMessage"
                    placeholder="相应计算机型号、数量等"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="经营范围" label-width="181px">
                  <el-checkbox-group v-model="form.publicationInfo.publicationScope">
                    <el-checkbox-button :label="item.name" name="type" v-for="item in publicationScope"
                      :key="item.id">{{
                        item.name
                      }}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="含网上销售">
                  <el-radio-group v-model="form.publicationInfo.isNetwork">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="2">否</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="hood-title"><span class="tips">工作人员登记表</span></div>
            <el-button type="primary" @click="addPublicationPerple">添加</el-button>
            <el-table :data="form.publicationInfo.practitionersLs" stripe style="width: 100%">
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="姓名"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sex" placeholder="性别"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="cerno" label="身份证号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.cerno" placeholder="身份证号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="politicalStatus" label="政治面貌">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.politicalStatus" placeholder="政治面貌"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="educationalAttainment" label="文化程度">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.educationalAttainment" placeholder="文化程度"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="job" label="职务">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.job" placeholder="职务"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="border-box" v-if="form.marsterName.includes(4)">
            <div class="hood-title">道路货物运输经营许可</div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="拟申请的道路货物运输经营范围或拟申请扩大的道路货物运输经营范围" label-width="auto">
                  <el-checkbox-group v-model="form.roadFreight.carType">
                    <el-checkbox-button :label="item.name" name="type" v-for="item in roadTransport" :key="item.id">{{
                      item.name
                    }}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="如拟申请扩大道路货物运输经营范围，请选择现有的经营范围" label-width="auto">
                  <el-checkbox-group v-model="form.roadFreight.carKd">
                    <el-checkbox-button :label="item.name" name="type" v-for="item in roadTransport" :key="item.id">{{
                      item.name
                    }}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="hood-title"><span class="tips">货物运输车辆信息 （可附表）</span></div>
            <el-button type="primary" @click="addCarList">添加</el-button>
            <el-table :data="form.roadFreight.carList" stripe style="width: 100%">
              <el-table-column prop="num" label="序号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="序号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="model" label="厂牌型号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.model" placeholder="厂牌型号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.count" placeholder="数量"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="loadCapacity" label="载重质量（吨）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.loadCapacity" placeholder="载重质量（吨）"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="technicalGrade" label="车辆技术等级">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.technicalGrade" placeholder="车辆技术等级"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="外廓尺寸（毫米）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.size" placeholder="外廓尺寸（毫米）"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div class="hood-title"><span class="tips">拟购置货物运输车辆信息 （可附表）</span></div>
            <el-button type="primary" @click="addPurchaseCarList">添加</el-button>
            <el-table :data="form.roadFreight.purchaseCarList" stripe style="width: 100%">
              <el-table-column prop="num" label="序号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="序号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="model" label="厂牌型号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.model" placeholder="厂牌型号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.count" placeholder="数量"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="loadCapacity" label="载重质量（吨）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.loadCapacity" placeholder="载重质量（吨）"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="technicalGrade" label="车辆技术等级">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.technicalGrade" placeholder="车辆技术等级"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="外廓尺寸（毫米）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.size" placeholder="外廓尺寸（毫米）"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="form.roadFreight.carKd.length">
              <div class="hood-title"><span class="tips">现有运输车辆信息 （可附表）</span></div>
              <el-button type="primary" @click="addExistingCarList">添加</el-button>
              <el-table :data="form.roadFreight.existingCarList" stripe style="width: 100%">
                <el-table-column prop="num" label="序号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.num" placeholder="序号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="no" label="道路运输证号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.no" placeholder="道路运输证号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="model" label="厂牌型号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.model" placeholder="厂牌型号"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="count" label="数量">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.count" placeholder="数量"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="loadCapacity" label="载重质量（吨）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.loadCapacity" placeholder="载重质量（吨）"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="technicalGrade" label="车辆技术等级">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.technicalGrade" placeholder="车辆技术等级"></el-input>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="size" label="外廓尺寸（毫米）">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.size" placeholder="外廓尺寸（毫米）"></el-input>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
            <div class="hood-title"><span class="tips">拟聘用营运货车驾驶员情况（可附表）</span></div>
            <el-button type="primary" @click="addPilotList">添加</el-button>
            <el-table :data="form.roadFreight.pilotList" stripe style="width: 100%">
              <el-table-column prop="num" label="序号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.num" placeholder="序号"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="姓名"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sex" placeholder="性别"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.age" placeholder="年龄"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="取得驾驶证时间">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.time" placeholder="取得驾驶证时间"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="no" label="从业资格证号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.no" placeholder="从业资格证号"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="border-box" v-if="form.marsterName.includes(6)">
            <div class="hood-title">户外招牌设施设置规范管理</div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="姓名">
                  <el-input v-model="form.outdoorAdvertising.name" placeholder="姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input v-model="form.outdoorAdvertising.phone" placeholder="手机号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证号">
                  <el-input v-model="form.outdoorAdvertising.idCard" placeholder="身份证号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="招牌名称">
                  <el-input v-model="form.outdoorAdvertising.storeName" placeholder="招牌名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="hood-title"><span class="tips">规 格</span></div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="长(厘米)">
                  <el-input v-model="form.outdoorAdvertising.shopSpecHeight" placeholder="长(厘米)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="宽(厘米)">
                  <el-input v-model="form.outdoorAdvertising.shopSpecWeight" placeholder="宽(厘米)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="面积(㎡)">
                  <el-input v-model="shopSpec" placeholder="面积(㎡)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="所属街道">
                  <el-select v-model="form.outdoorAdvertising.isChange" placeholder="请选择所属街道">
                    <el-option v-for="item in streetList" :key="item.code" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="您的店铺位置">
                  <el-input v-model="form.outdoorAdvertising.address"
                    placeholder="您的店铺位置(此处须填写到XX街道办事处XX街（路）XX号)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="您是否了解《潍坊市户外广告和招牌设置管理办法》" label-width="auto">
                  <el-radio-group v-model="form.outdoorAdvertising.know">
                    <el-radio-button label="0">了解</el-radio-button>
                    <el-radio-button label="1">不了解</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="border-box" v-if="form.marsterName.includes(7)">
          <div class="hood-title">创业担保贷款申请</div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="法人姓名">
                <el-input v-model="form.entrepreneurialLoan.faName" placeholder="法人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号">
                <el-input v-model="form.entrepreneurialLoan.idCard" placeholder="身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="文化程度">
                <el-input v-model="form.entrepreneurialLoan.educationalAttainment" placeholder="文化程度"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="资产总规模（万元）">
                <el-input v-model="form.entrepreneurialLoan.totalAssetScale" placeholder="资产总规模（万元）"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资产负债率%">
                <el-input v-model="form.entrepreneurialLoan.debtRatio" placeholder="资产负债率%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年营业收入（万元）">
                <el-input v-model="form.entrepreneurialLoan.annualRevenue" placeholder="年营业收入（万元）"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="申请贷款额（万元）">
                <el-input v-model="form.entrepreneurialLoan.applyForCredit" placeholder="申请贷款额（万元）"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职工总人数">
                <el-input v-model="form.entrepreneurialLoan.employeesNumber" placeholder="职工总人数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="安置符合规定的人员数">
                <el-input v-model="form.entrepreneurialLoan.placementNumber" placeholder="安置符合规定的人员数"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="法定代表人签字">
                <el-button type="primary" @click="toSign(2)">签字</el-button>
              </el-form-item>
            </el-col> -->
          </el-row>
        </div>
        <div class="border-box" v-if="form.marsterName.includes(2)">
          <div class="hood-title">食品小餐饮登记</div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="经营者名称">
                <el-input v-model="form.smallFoodBusiness.operator" placeholder="经营者名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="经营地址">
                <el-input v-model="form.smallFoodBusiness.address" type="textarea"
                  placeholder="经营地址(市/县(区)/乡镇(街/道))"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="社会信用代码">
                <el-input v-model="form.smallFoodBusiness.uniscid" placeholder="社会信用代码（工商注册登记号）"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="负责人（业主）姓名">
                <el-input v-model="form.smallFoodBusiness.lerep" placeholder="负责人（业主）姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证">
                <el-input v-model="form.smallFoodBusiness.cerno" placeholder="身份证"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="联系电话">
                <el-input v-model="form.smallFoodBusiness.tel" placeholder="联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经营场所面积">
                <el-input v-model="form.smallFoodBusiness.area" placeholder="经营场所面积"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="就餐座位数">
                <el-input v-model="form.smallFoodBusiness.seatsNumber" placeholder="就餐座位数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="从业人员数">
                <el-input v-model="form.smallFoodBusiness.employeesNumber" placeholder="从业人员数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="应体检人数">
                <el-input v-model="form.smallFoodBusiness.undergoingNumber" placeholder="应体检人数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="hood-title"><span class="tips">委托代理人</span></div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="代理人姓名">
                <el-input v-model="form.smallFoodBusiness.agentName" placeholder="代理人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="代理人电话">
                <el-input v-model="form.smallFoodBusiness.agentTel" placeholder="代理人电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="hood-title"><span class="tips">经营项目</span></div>
          <el-row>
            <el-col :span="24">
              <el-form-item label="经营项目 ">
                <el-checkbox-group v-model="form.smallFoodBusiness.scope">
                  <el-checkbox-button :label="item.id" name="type" v-for="item in xspList" :key="item.id">{{
                    item.name
                  }}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="4">
            <el-form-item label="上传文件">
              <el-button type="primary" @click="generateQrcode">上传文件</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="二维码">
              <canvas id="qrCode" class="code-img"></canvas>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- ================================== 模板 =========================================== -->
        <!-- v-if="form.marsterName.includes(6)" -->
        <!-- <div class="border-box">
          <div class="hood-title">替换标题</div>
        </div> -->
        <!-- <el-row>
          <el-col :span="8">
            <el-form-item label="名称">
              <el-input v-model="form.name"  placeholder="出版物发行申请项目内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="住所(经营场所)">
              <el-input v-model="form.name"  placeholder="出版物发行申请项目内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <el-input v-model="form.name"  placeholder="出版物发行申请项目内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- =============================================================================================== -->
      </el-form>
      <div class="td"></div>
      <div class="sign-mask" v-if="signShow" @click="signShow = false">
        <div class="sign-box" @click.stop="">
          <SignName :signTitle="signTitle" @handleGenerate="handleGenerate" />
        </div>
      </div>
      <div class="submit-mask" v-if="loading" v-loading="loading" element-loading-text="正在提交">
      </div>
    </div>
    <Back @toBack="toBack" :print="3" @toSubmit="toSubmit" />
  </div>
</template>
<script>
import scopeList from "@/assets/js/people/ggwsScope.js";
import applyProject from "@/assets/js/people/applyProject.js";
import submitForm from "@/assets/js/people/submitForm.js";
import publicationScope from "@/assets/js/people/publicationScope.js";
import roadTransport from "@/assets/js/people/roadTransport.js";
import streetList from "@/assets/js/people/streetList.js";
import xspList from "@/assets/js/people/xspList.js";
import { v4 as uuidv4 } from "uuid";
import QRCode from "qrcode";
import SignName from "@/components/people/signName.vue";
export default {
  components: {
    SignName
  },
  data() {
    return {
      uuid: "",//唯一id
      enterprise: false,//展示企业信息
      signShow: false,//签名框显示
      signTitle: "",//签名框标题
      signType: 1,//签字类型 1 指定代表/委托代理人签字 2法定代表人
      form: {
        // ================ 基本信息 ===================
        token: "",//token
        entName: "企业名称",//企业名称
        entAddress: "住所（经营场所）", //住所（经营场所）
        ECommerce: "1",//电商企业
        entPostalCode: "邮政编码",//邮政编码
        entTel: "13333333333",//企业联系电话
        entType: "2",//企业类型（组成形式）
        entEstablishment: "1",// 设立方式（股份公司填写）
        entCapital: "100", //注册资本（万元）
        // applyLicense: true, //申领执照
        applyLicense: '1', //申领执照
        entMailType: "1", //文书送达方式
        mailAddress: "邮寄地址",//邮寄地址
        licenseScope: "经营范围",//经营范围
        // ================ 法定代表人 ===================
        lerepName: "法人姓名",//法人姓名
        lerepCountry: "中国",//国别
        lerepPosition: "1",//职务
        lerepProduceType: "产生方式",//产生方式
        lerepEducational: "学历",//学历
        lerepJob: "职称",//职称
        lerepCernoType: "身份证",//身份证件类型
        lerepCerno: "370000000000000000",//身份证
        lerepTel: "13333333333",//移动电话
        lerepEmail: "123456789@qq.com",//电子邮箱
        lerepDJAddress: "证件登记住址",//证件登记住址
        lerepAddress: "现住址",//现住址
        // ================ 董事、监事、经理信息 ===================
        directorMessage: [{
          name: "姓名",//,//姓名
          country: "中国",//民族
          cernoType: "身份证",//性质
          cerno: "370000000000000000",//身份证号码
          job: "职务",//职务
          generationMode: "产生方式",//产生方式
        }],
        // ================ 股东（发起人）、外国投资者出资情况(必填项） ===================
        shareholderMessage: [
          {
            name: "姓名",//姓名
            country: "中国",//国别
            cernoType: "身份证",//证件类型
            cerno: "370000000000000000",//身份证号码
            contributionAmount: "认缴",//认缴
            investmentAmount: "实缴",//投资金额
            contributeTime: "出资时间",//出资时间
            investmentType: "投资方式",//投资方式
            investmentRatio: "投资比例",//投资比例
          }
        ],
        // ================ 联络员信息(必填项） ===================
        contactName: "联系人姓名",//联络员姓名
        contactPhone: "123456789",//固定电话
        contactTel: "13333333333",//联系电话
        contactEmail: "123456789@qq.com",//联系邮箱
        contactCernoType: "身份证",//联络员身份证类型
        contactCerno: "370000000000000000",//联络员身份证
        // ================ 指定代表/委托代理人（必填项） ===================
        CheckRadio: "1",//核对登记材料中的复印件并签署核对意见
        ModifyRadio: "1",//修改企业自备文件的错误
        ChangeRadio: "1",//修改有关表格的填写错误
        CollectRadio: "1",//领取营业执照和有关文书
        representativePhone: "固话",//固话
        representaTel: "13333333333",//代表人电话
        // ================ 财务负责人信息 ===================
        financialName: "财务负责人姓名",//财务负责人姓名
        financialPhone: "13333333333",//财务负责人固话
        financialTel: "13333333333",//财务负责人电话
        financialEmail: "123456789@qq.com",//财务负责人邮箱
        financialCernoType: "身份证",//财务负责人身份证类型
        financialCerno: "370000000000000000",//财务负责人身份证
        // ================ 其他信息(核算方式 ) ===================
        accountingType: "1",//核算方式
        // ================ 印章备案信息 ===================
        whichBelongs: "所属地市",//所属地市
        whichPrefecture: '区县',//区县
        whichEntName: '刻章企业名称',//刻章企业名称
        // ================ 申请事项情况 ===================
        marsterName: [],//申请项目选中的项目列表
        // ===================公共场所卫生 / 食品经营许可=======================
        industryHygieneLicense: {
          employeeNumber: "10",//员工人数
          physicalNumber: "10",//体检人数
          fixedAssets: "100",//固定资产（万）
          usableArea: "130",//使用面积
          isAirConditioning: "1",//是否中央空调 0 无 1 有
          applyProject: "申请经营项目",//申请经营项目
          licenseScope: ["美容店"],//许可范围
          // =====================食品经营==========================
          prefabricatedFood: "0",//预包装食品销售 0、含冷藏冷冻食品 1、含冷藏冷冻食品
          bulkFood: "1",//散装食品销售 0、散装食品销售 1、含冷藏冷冻食品不含熟食 2、含冷藏冷冻食品不含熟食 3、不含冷藏冷冻食品不含熟食
          specialFood: "1",//特殊食品销售 0、婴幼儿配方乳粉 1、其他婴幼儿配方食品 2、保健食品销售 3、保健食品销售 4、热食类食品制售 5、热食类食品制售 6、生食类食品制售 7、糕点类制售（含裱花蛋糕）8、糕点类制售（不含裱花蛋糕）9、自制饮品制售（不含使用压力容器制作饮品） 10、其他类食品销售
          isWine: "1",//如申请自制饮品制售，是否含自酿酒制售 0 否 1 是
          vendingMachine: "1",//是否利用自动售货设备从事食品销售
          isNetwork: "1",//是否含网络经营 0否 1 是
          practitionersLs: [],//从业人员信息 （数组）
          technicalPersonnel: [],//安全、质量管理人员、专业技术人员情况（数组）
          equipmentCcondition: []//设备情况
        },
        shipinPeople: [
          {
            name: "",//姓名
            sex: "",//性别
            nationality: "",//民族
            educational: "",//学历
            nature: "食品安全管理人员",//岗位性质
            cerno: "",//身份证号码
            job: "",//职务
            tel: "",//联系电话
          },
          {
            name: "",//姓名
            sex: "",//性别
            nationality: "",//民族
            educational: "",//学历
            nature: "食品安全专业技术人员",//岗位性质
            cerno: "",//身份证号码
            job: "",//职务
            tel: "",//联系电话
          },
          {
            name: "",//姓名
            sex: "",//性别
            nationality: "",//民族
            educational: "",//学历
            nature: "卫生管理人员",//岗位性质
            cerno: "",//身份证号码
            job: "",//职务
            tel: "",//联系电话
          }
        ],//食品经营许可人员
        shipinPractitioners: [{
          name: "姓名",//姓名
          sex: "性别",//性别
          nationality: "民族",//民族
          cerno: "身份证",//身份证
          tel: "电话",//电话
          jkzNo: "健康证编号",//健康证编号
          jobType: "工种",//工种
          unit: "发证单位"//发证单位
        }],//食品经营许可从业人员情况
        shipinEquipment: [{
          num: "序号",//序号
          name: "名称",//名称
          count: "数量",//数量
          address: "位置",//位置
          remark: "备注"
        }],//食品经营许可设备情况
        // ==========================出版物===============================
        publicationInfo: {
          // id: "string",
          // peopleOnethingId: "string",
          name: "姓名",//发行内容
          usedArea: "自有",//自有面积
          leasedArea: "租用",//租用面积
          warehouseArea: "仓库",//仓库面积
          computerMessage: "电脑信息",//电脑信息
          publicationScope: ['电子出版物'],//经营范围
          isNetwork: "2",//网上销售
          practitionersLs: [
            {
              name: "姓名",//姓名
              sex: "性别",//性别
              cerno: "身份证号码",//身份证号码
              politicalStatus: "政治面貌",//政治面貌
              educationalAttainment: "文化程度",//文化程度
              job: "职务",//职务
            }
          ],//人员信息
        },
        // publicationPerpleList: [
        //   {
        //     name: "姓名",//姓名
        //     sex: "性别",//性别
        //     cerno: "身份证号码",//身份证号码
        //     politicalStatus: "政治面貌",//政治面貌
        //     educationalAttainment: "文化程度",//文化程度
        //     job: "职务",//职务
        //   }
        // ],//出版物人员登记表
        // =============================== 道路运输 =====================================
        roadFreight: {
          // id: "string",
          // peopleOnethingId: "string",
          carType: ["普通货运"],
          carKd: ["普通货运"],
          carList: [ //货物运输车辆信息 （可附表）
            {
              num: "1",//序号
              model: "型号",//型号
              count: "数量",//数量
              loadCapacity: "载重质量（吨）",//载重质量（吨）
              technicalGrade: "车辆技术等级",//车辆技术等级
              size: "尺寸",//尺寸
            }
          ],
          purchaseCarList: [
            {
              num: "1",//序号
              model: "型号",//型号
              count: "数量",//数量
              loadCapacity: "载重质量（吨）",//载重质量（吨）
              technicalGrade: "车辆技术等级",//车辆技术等级
              size: "尺寸",//尺寸
            }
          ], //拟购置货物运输车辆信息 （可附表）
          existingCarList: [
            {
              num: "1",//序号
              no: "道路运输证号",//车辆编号
              model: "型号",//型号
              count: "数量",//数量
              loadCapacity: "载重质量（吨）",//载重质量（吨）
              technicalGrade: "车辆技术等级",//车辆技术等级
              // size: "尺寸",//尺寸
            }
          ],//现有运输车辆信息 （可附表）（仅限申请扩大经营范围填写）
          pilotList: [
            {
              num: "1",//序号
              name: "姓名",//姓名
              sex: "性别",//性别
              age: "年龄",//年龄
              time: "获取驾驶证时间",//获取驾驶证时间
              no: "从业资格证号",//从业资格证号
            }
          ]//拟聘用营运货车驾驶员情况（可附表）
        },
        // ========================== 户外广告 ===============================
        outdoorAdvertising: {
          // openId: "",
          name: "姓名",//姓名
          phone: "1333333333",//手机号
          idCard: "370000000000000000",//身份证
          storeName: "店铺名",//店铺名
          address: "店铺位置",//地址
          know: "0",//是否知晓
          isChange: "",//所属街道
          shopSpecHeight: "130", //长
          shopSpecWeight: "260", //宽
          // positionPhoto1: [],
          // daytimePhoto1: [],
          // nightPhoto1: [],
          // idCardPhoto1: [],
          // businessLicense1: [],
          // contractPhoto1: [],
          positionPhoto: "",
          daytimePhoto: "",
          nightPhoto: "",
          idCardPhoto: "",
          businessLicense: "",
          contractPhoto: "",
          // id: "string",
          // peopleOnethingId: "string",
          // name: "招牌名",//招牌名
          // longLeng: "长",//长
          // houLong: "宽",//宽
          // tallLong: "高",//高
        },
        // ============================= 创业担保贷款 ==============================
        entrepreneurialLoan: {
          // id: "string",
          // peopleOnethingId: "string",
          faName: "法人姓名",//法人姓名
          idCard: "身份证号",//身份证号
          educationalAttainment: "文化程度",//文化程度
          totalAssetScale: "资产总规模（万元）",//资产总规模（万元）
          debtRatio: "资产负债率",//资产负债率
          annualRevenue: "年营收",//年营收
          applyForCredit: "申请的额度",//申请的额度
          employeesNumber: 10,//职工总人数
          placementNumber: 6//安置符合规定的人员数
        },
        // ==========================小食品===============================
        smallFoodBusiness: {
          operator: "经营者名称",//经营者名称
          address: "经营地址",//经营地址
          uniscid: "社会信用代码",//社会信用代码
          lerep: "负责人",//负责人
          cerno: "身份证",//身份证
          tel: "13333333333",//联系电话
          area: "经营场所面积",//经营场所面积
          seatsNumber: "100",//就餐座位数
          employeesNumber: "11",//从业人员数
          undergoingNumber: "11",//应体检人数
          agentName: "代理人姓名",//代理人姓名
          agentTel: "代理人电话",//代理人电话
          scope: [3],//经营范围
        }
        // ==================================== 下一项 ===========================================
      },
      applyProject: [],//项目申请列表
      scopeList: [],//公共卫生许可范围列表
      submitForm: [],//提交表单
      // =======================================
      publicationScope: [],//出版物许可范围
      roadTransport: [],//道路运输许可范围
      onethingUrls: [],//上传材料
      streetList: [], //街道列表
      xspList: [],//小食品经营范围
      loading: false
    }
  },
  // destroyed() {
  //   this.closeCamera()
  // },
  created() {
    this.applyProject = applyProject //申请事项
    this.scopeList = scopeList //卫生许可证经营范围
    this.submitForm = submitForm //提交表单
    this.publicationScope = publicationScope //出版物
    this.roadTransport = roadTransport //道路运输
    this.streetList = streetList //街道
    this.xspList = xspList //小食品经营范围
    this.uuid = uuidv4().replaceAll("-", "");
    this.getTemporaryToken()
    this.getSMfirm()  //获取企业信息
  },
  computed: {
    shopSpec: {
      get() {
        var h, w
        if (this.form.outdoorAdvertising.shopSpecHeight == '') {
          h = 0
        } else {
          h = Number(this.form.outdoorAdvertising.shopSpecHeight) / 100
        }
        if (this.form.outdoorAdvertising.shopSpecWeight == '') {
          w = 0
        } else {
          w = Number(this.form.outdoorAdvertising.shopSpecWeight) / 100
        }
        return (h * w).toFixed(2)
      },
      set(val) { }
    }
  },
  methods: {
    getSMfirm() {
      // var userInfo = this.$store.state.suerInfo
      // userInfo.cerno
      var cerno = this.$doSm4('372928198209204926')
      this.$rqt.sms_getInfoList(cerno).then(res => {
        var data = this.$dptSm4(res)
        console.log(JSON.parse(data));
        var arr = JSON.parse(data)
        if (arr.baseinfos.length > 0) {
          this.enterprise = false
        } else {
          this.enterprise = true
        }
      })
    },
    // 获取文件列表
    getFileList() {
      // 
      // {
      //   fileUrls: "string",
      //     fileKey: "string"
      // }
      this.$rqt.common_getRecord({
        key: this.uuid
      }).then(res => {
        if (!res.data) {
          this.submitForm.onethingUrls = this.onethingUrls
          this.onSubmit()
          return
        }
        var list = res.data
        // clog.a('文件列表', list)
        list.forEach(elemetnt => {
          elemetnt.list.forEach(ele => {
            ele.files.forEach(el => {
              if (this.onethingUrls.find(el => el.fileKey == ele.title)) {
                var idx = this.onethingUrls.findIndex(el => el.fileKey == ele.title)
                var fileArr = this.onethingUrls[idx].fileUrls.split(',')
                fileArr.push(el.url)
                this.onethingUrls[idx].fileUrls = fileArr.join(',')
              } else {
                this.onethingUrls.push({
                  fileUrls: el.url,
                  fileKey: ele.title
                })
              }
            });
          })
          // 正式版本打开
          if (elemetnt.adminTitle == '户外招牌设置') {
            this.setOutdoorsFiles(elemetnt)
          }
        });
        this.submitForm.onethingUrls = this.onethingUrls
        this.onSubmit()
      })
    },
    // 筛选户外广告文件
    setOutdoorsFiles(elemetnt) {
      this.form.outdoorAdvertising.positionPhoto = this.setListUrl(elemetnt.list[0].files)
      this.form.outdoorAdvertising.daytimePhoto = this.setListUrl(elemetnt.list[1].files)
      this.form.outdoorAdvertising.nightPhoto = this.setListUrl(elemetnt.list[2].files)
      this.form.outdoorAdvertising.idCardPhoto = this.setListUrl(elemetnt.list[3].files)
      this.form.outdoorAdvertising.businessLicense = this.setListUrl(elemetnt.list[4].files)
      this.form.outdoorAdvertising.contractPhoto = this.setListUrl(elemetnt.list[5].files)
      this.$rqt.shopSign_insert(this.form.outdoorAdvertising).then(res => {
        clog.a('提交完成', res)
      })
    },
    setListUrl(data) {
      var url = []
      data.forEach(el => {
        url.push(el.url)
      })
      return url.join(',')
    },
    // 提交处理后表单信息
    onSubmit() {
      clog.a('提交处理后表单信息', this.submitForm)
      var val = JSON.stringify(this.submitForm)
      var data = this.$doSm4(val, 'da7b1ede03d7d2a7')
      console.log('submit!', { data });
      this.$rqt.peopleOnething_add({ data }).then(res => {
        clog.a('提交处理后表单信息', res)
        this.loading = false
      })
    },
    // 提交原表单(未处理)
    toSubmit() {
      this.loading = true
      // clog.a('原表单', this.form)
      // ==================================== 基本信息 ====================================
      const { entName, entAddress, entTel, entType, entEstablishment, entCapital, applyLicense, entMailType, mailAddress, licenseScope, ECommerce,
        entPostalCode } = this.form
      var operatorMessage = {
        entName,//企业名称
        entAddress, //住所（经营场所）
        entTel,//企业联系电话
        entType,//企业类型（组成形式）
        entEstablishment,// 设立方式（股份公司填写）
        entCapital, //注册资本（万元）
        applyLicense, //申领执照
        entMailType, //文书送达方式
        mailAddress,//邮寄地址
        licenseScope,//经营范围
        ECommerce,//电商企业
        entPostalCode,//邮政编码
      }
      clog.b('基本信息operatorMessage', operatorMessage)
      // ==================================== 法人信息 ====================================
      const { lerepName, lerepCountry, lerepPosition, lerepProduceType, lerepEducational, lerepJob, lerepCernoType, lerepCerno, lerepTel, lerepEmail, lerepDJAddress, lerepAddress } = this.form
      var legalMessage = {
        lerepName,//法人姓名
        lerepCountry,//国别
        lerepPosition,//职务
        lerepProduceType,//产生方式
        lerepEducational,//学历
        lerepJob,//职称
        lerepCernoType,//身份证件类型
        lerepCerno,//身份证
        lerepTel,//移动电话
      }
      clog.c('legalMessage法人', legalMessage)
      // ================ 董事、监事、经理信息 ===================
      clog.d('directorMessage董事', this.form.directorMessage)
      // ================ 股东（发起人）、外国投资者出资情况(必填项） ===================
      clog.e('shareholderMessage股东', this.form.shareholderMessage)
      // ==================================== 联络员信息 ====================================
      const { contactName, contactPhone, contactTel, contactEmail, contactCernoType, contactCerno } = this.form
      var liaisonMessage = {
        contactName,//联系人姓名
        contactPhone,//固定电话
        contactTel,//联系电话
        contactEmail,//联系邮箱
        contactCernoType,//联系人身份证类型
        contactCerno,//联系人身份证
      }
      clog.f('liaisonMessage联络员', liaisonMessage)
      // ================ 指定代表/委托代理人（必填项） ===================
      const { CheckRadio, ModifyRadio, ChangeRadio, CollectRadio, representativePhone, representativeTel } = this.form
      var dlMessage = {
        CheckRadio,//核对登记材料中的复印件并签署核对意见
        ModifyRadio,//修改企业自备文件的错误
        ChangeRadio,//修改有关表格的填写错误
        CollectRadio,//领取营业执照和有关文书
        representativePhone,//固话
        representativeTel,//代表人电话
      }
      clog.g('dlMessage指定代表', dlMessage)
      // ================ 财务负责人信息 ===================

      // financialName: "财务负责人姓名",//财务负责人姓名
      //   financialPhone: "13333333333",//财务负责人固话
      //     financialTel: "13333333333",//财务负责人电话
      //       financialEmail: "123456789@qq.com",//财务负责人邮箱
      //         financialCernoType: "身份证",//财务负责人身份证类型
      //   financialCerno: "370000000000000000",//财务负责人身份证
      const { financialName, financialPhone, financialTel, financialEmail, financialCernoType, financialCerno } = this.form
      var financeMessage = {
        financialName,//财务负责人姓名
        financialPhone,
        financialTel,
        financialEmail,
        financialCernoType,
        financialCerno,
      }
      clog.h('financeMessage财务负责人', financeMessage)
      // ================ 其他信息(核算方式 ) ===================
      clog.a("accountingType核算方式", this.form.accountingType)
      // ================ 印章备案信息 ===================
      const { whichBelongs, whichPrefecture, whichEntName } = this.form
      var sealFiling = {
        whichBelongs,//属于
        whichPrefecture,//所属区划
        whichEntName,//企业名称
      }
      clog.b('sealFiling印章备案信息', sealFiling)
      // ================ 申请项目 ===================
      var marsterName = this.form.marsterName.join(',')
      clog.c("marsterName申请项目", marsterName)
      // =============================================================
      // form.industryHygieneLicense.licenseScope
      clog.d("industryHygieneLicense公共卫生/食品经营", this.form.industryHygieneLicense)
      // =================食品经营安全技术人员==========================
      // shipinPractitioners 从业人员 shipinEquipment 设备情况
      // clog.f("shipinPeople食品经营安全技术人员", this.form.shipinPeople)
      this.form.industryHygieneLicense.technicalPersonnel = JSON.stringify(this.form.shipinPeople)  //安全技术人员
      this.form.industryHygieneLicense.practitionersLs = JSON.stringify(this.form.shipinPractitioners)  //从业人员
      this.form.industryHygieneLicense.equipmentCcondition = JSON.stringify(this.form.shipinEquipment) //设备情况
      // ================= 出版物信息 =================================
      clog.g("publicationInfo出版物信息", this.form.publicationInfo)
      // ================= 道路运输 =================================
      clog.h("roadFreight道路运输", this.form.roadFreight)
      // =================== 户外广告 ===========================
      clog.a("outdoorAdvertising户外广告", this.form.outdoorAdvertising)
      // =================== 创业担保贷款申请 ===========================
      clog.b("entrepreneurialLoan创业担保贷款申请", this.form.entrepreneurialLoan)
      this.submitForm.operatorMessage = JSON.stringify(this.form.operatorMessage) //基本信息
      this.submitForm.legalMessage = JSON.stringify(legalMessage) //法人信息
      this.submitForm.directorMessage = JSON.stringify(this.form.directorMessage) //董事
      this.submitForm.shareholderMessage = JSON.stringify(this.form.shareholderMessage) //股东
      this.submitForm.liaisonMessage = JSON.stringify(liaisonMessage) //联络员
      this.submitForm.dlMessage = JSON.stringify(dlMessage) //指定代表
      this.submitForm.financeMessage = JSON.stringify(financeMessage) //财务负责人
      this.submitForm.accountingType = this.form.accountingType //核算方式
      this.submitForm.sealFiling = JSON.stringify(sealFiling) //印章备案信息
      this.submitForm.industryHygieneLicense = this.form.industryHygieneLicense//公共卫生/食品经营
      this.submitForm.industryHygieneLicense.equipmentCcondition = JSON.stringify(this.form.industryHygieneLicense.equipmentCcondition) //公共卫生/食品经营
      this.submitForm.industryHygieneLicense.licenseScope = JSON.stringify(this.form.industryHygieneLicense.licenseScope) //公共卫生/食品经营
      this.submitForm.industryHygieneLicense.practitionersLs = JSON.stringify(this.form.industryHygieneLicense.practitionersLs) //公共卫生/食品经营
      this.submitForm.industryHygieneLicense.technicalPersonnel = JSON.stringify(this.form.industryHygieneLicense.technicalPersonnel) //公共卫生/食品经营
      this.submitForm.publicationInfo = this.form.publicationInfo //出版物
      this.submitForm.publicationInfo.practitionersLs = JSON.stringify(this.form.publicationInfo.practitionersLs) //出版物
      this.submitForm.publicationInfo.publicationScope = JSON.stringify(this.form.publicationInfo.publicationScope) //出版物
      this.submitForm.roadFreight = this.form.roadFreight //道路运输
      this.submitForm.roadFreight.carKd = JSON.stringify(this.form.roadFreight.carKd)
      this.submitForm.roadFreight.carType = JSON.stringify(this.form.roadFreight.carType)
      this.submitForm.roadFreight.carList = JSON.stringify(this.form.roadFreight.carList)
      this.submitForm.roadFreight.existingCarList = JSON.stringify(this.form.roadFreight.existingCarList)
      this.submitForm.roadFreight.pilotList = JSON.stringify(this.form.roadFreight.pilotList)
      this.submitForm.roadFreight.purchaseCarList = JSON.stringify(this.form.roadFreight.purchaseCarList)
      this.submitForm.outdoorAdvertising = this.form.outdoorAdvertising //户外广告purchaseCarList
      this.submitForm.entrepreneurialLoan = this.form.entrepreneurialLoan //创业担保贷款申请
      this.submitForm.smallFoodBusiness = this.form.smallFoodBusiness //小食品经营
      this.submitForm.marsterName = marsterName
      this.getFileList()
    },
    // 添加董事/监事/经理
    addLeadership() {
      this.form.directorMessage.push({
        name: "",//姓名
        country: "",//民族
        cernoType: "",//性质
        cerno: "",//身份证号码
        job: "",//职务
        generationMode: "",//产生方式
      })
    },
    // 添加股东
    addShareholder() {
      this.form.shareholderMessage.push({
        name: "",//姓名
        country: "",//国别
        cernoType: "",//证件类型
        cerno: "",//身份证号码
        contributionAmount: "",//认缴
        investmentAmount: "",//实缴
        contributeTime: "",//出资时间
        investmentType: "",//投资方式
        investmentRatio: "",//投资比例
      })
    },
    // 添加从业人员情况
    addShipinPractitioners() {
      this.form.shipinPractitioners.push({
        name: "",//姓名
        sex: "",//性别
        nationality: "",//民族
        cerno: "",//身份证
        tel: "",//电话
        jkzNo: "",//健康证编号
        jobType: "",//工种
        unit: ""//发证单位
      })
    },
    // 添加设备
    addShipinEquipment() {
      this.form.shipinEquipment.push(
        {
          num: "",//序号
          name: "",//名称
          count: "",//数量
          address: "",//位置
          remark: ""
        }
      )
    },
    // 出版物添加工作人员
    addPublicationPerple() {
      this.form.publicationInfo.practitionersLs.push({
        name: "",//姓名
        sex: "",//性别
        cerno: "",//身份证号码
        politicalStatus: "",//政治面貌
        educationalAttainment: "",//文化程度
        job: "",//职务
      })
    },
    // 货物运输车辆信息
    addCarList() {
      this.form.roadFreight.carList.push({
        num: "",//序号
        model: "",//型号
        count: "",//数量
        loadCapacity: "",//载重质量（吨）
        technicalGrade: "",//车辆技术等级
        size: "",//尺寸
      })
    },
    // 添加拟购置货物运输车辆信息
    addPurchaseCarList() {
      this.form.roadFreight.purchaseCarList.push({
        num: "",//序号
        model: "",//型号
        count: "",//数量
        loadCapacity: "",//载重质量（吨）
        technicalGrade: "",//车辆技术等级
        size: "",//尺寸
      })
    },
    // 添加现有运输车辆信息
    addExistingCarList() {
      this.form.roadFreight.existingCarList.push({
        num: "",//序号
        no: "",//道路运输证号
        model: "",//型号
        count: "",//数量
        loadCapacity: "",//载重质量（吨）
        technicalGrade: "",//车辆技术等级
        // size: "",//尺寸
      })
    },
    //添加驾驶员
    addPilotList() {
      this.form.roadFreight.pilotList.push({
        num: "",//序号
        name: "",//姓名
        sex: "",//性别
        age: "",//年龄
        time: "",//获取驾驶证时间
        no: "",//从业资格证号
      })
    },
    // 获取临时token
    getTemporaryToken() {
      this.$rqt.common_getTemporaryToken().then(res => {
        // console.log(res);
        this.submitForm.token = res.data
      })
    },
    // 生成二维码
    generateQrcode() {
      var type = this.form.marsterName.join(',')
      var cerno = '0'
      if (this.enterprise) {
        cerno = '1'
      }
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数 
      // var url = `http://192.168.103.182:8080//#/peopleUploadFiles?type=${type}&uuid=${this.uuid}&cerno=${cerno}&common=1`
      var url = `https://l.zwfwpt.cn/#/peopleUploadFiles?type=${type}&uuid=${this.uuid}&cerno=${cerno}&common=1`
      console.log(url);
      QRCode.toCanvas(
        canvas,
        url,
        function (error) {
          if (error) {
            console.error(error);
          } else {
            console.log("success!");
          }
        }
      );
    },
    toSign(type) {
      this.signType = type
      if (type == 1) {
        this.signTitle = '指定代表/委托代理人签字'
      } else {
        this.signTitle = '法定代表人签字'
      }
      this.signShow = true
    },
    handleGenerate(signUrl) {
      clog.a('signUrl', signUrl)
    },
    toBack() {
      this.$router.back();
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #F1FAFC;
  overflow-y: scroll;
  position: relative;
}

.content::-webkit-scrollbar {
  width: 0;
}

.border-box {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}

.hood-title {
  font-size: 5rem;
  font-weight: bold;
  margin-left: 10rem;
  margin-bottom: 5rem;
  text-align: center;

  .tips {
    font-weight: 100;
  }
}

.zh {
  height: 20px;
}

.td {
  height: 35rem;
}

.sign-mask {
  width: 100%;
  // height: 100%;
  height: calc(100vh - 42rem);
  position: fixed;
  background-color: rgba($color: #000000, $alpha: .3);
  top: 26rem;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .sign-box {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 20px;
  }
}

.submit-mask {
  width: 100%;
  height: calc(100vh - 42rem);
  position: fixed;
  top: 26rem;
  left: 0;
}
</style>